import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function quickScrollBlocking(triggerSelector, className) {
  const triggerEl = document.querySelector(triggerSelector);
  if (!triggerEl) {
    return;
  }

  // 1. Establecer el estado inicial: la clase está en el body por defecto.
  document.body.classList.add(className);

  // 2. Crear el ScrollTrigger para vigilar la sección.
  ScrollTrigger.create({
    trigger: triggerSelector,
    start: "top center",      // Se activa cuando la parte superior de la sección llega al centro
    end: "bottom center",   // Se desactiva cuando la parte inferior de la sección pasa el centro
    // 3. Quitar la clase al entrar a la sección (desde arriba o abajo)
    onEnter: () => document.body.classList.remove(className),
    onEnterBack: () => document.body.classList.remove(className),
    // 4. Añadir la clase de nuevo al salir de la sección (hacia arriba o abajo)
    onLeave: () => document.body.classList.add(className),
    onLeaveBack: () => document.body.classList.add(className),
  });
}